__turbopack_context__.v({
  "drawerButton": "J-wK-q_drawerButton",
  "drawerHeader": "J-wK-q_drawerHeader",
  "legendsToggle": "J-wK-q_legendsToggle",
  "legendsToggleSm": "J-wK-q_legendsToggleSm",
  "navItem": "J-wK-q_navItem",
  "sidebar": "J-wK-q_sidebar",
  "slogan": "J-wK-q_slogan",
  "title": "J-wK-q_title",
  "top10": "J-wK-q_top10",
  "top100": "J-wK-q_top100",
  "userPosition": "J-wK-q_userPosition",
});
